/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';
import { RangeControl, ToggleControl } from '@wordpress/components';

/**
 * Inner dependencies.
 */
import Accordion from '../../../components/Accordion';

const hookPrefix = `service`;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-content`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/content`,
	( content, props ) => {
		const templates = [ {
			name: 'layout-1',
			label: 'Layout 1',
			iconAlign: 'center',
			titleAlign: 'center',
			buttonAlign: 'center',
		}, {
			name: 'layout-2',
			label: 'Layout 2',
			iconAlign: 'center',
			titleAlign: 'left',
			buttonAlign: 'left',
		}, {
			name: 'layout-3',
			label: 'Layout 3',
			iconAlign: 'center',
			titleAlign: 'right',
			buttonAlign: 'right',
		} ];
		const { attributes, setAttributes, updateInnerBlocks } = props;
		const { layout, columnSize, hideButtons } = attributes;
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion tabs={ [
					{
						name: 'service',
						initialOpen: true,
						label: () => {
							return __( 'Service' );
						},
						cb: () => {
							return <>
								<RangeControl value={ columnSize } label={ __( 'Columns' ) } min={ 1 } max={ 4 } step={ 1 } onChange={ ( value ) => {
									setAttributes( { columnSize: value } );
								} } />
								<ToggleControl label={ __( 'Hide Buttons' ) } onChange={ () => {
									setAttributes( {
										hideButtons: ! hideButtons,
									} );
								} } checked={ hideButtons } help={
									hideButtons ? __( 'All buttons are hidden' ) : __( 'All buttons are shown.' )
								} />
							</>;
						},
					},
					{
						name: 'info-box',
						initialOpen: true,
						label: () => {
							return __( 'Info Box' );
						},
						cb: () => {
							return <>
								{ templates && <div className="gutenify-template-browser">
									<h2>Templates</h2>

									<ul>
										{ templates.map( ( template ) => {
											let classnames = 'gutenify-template-browser-item';
											if ( layout === template.name ) {
												classnames += ' gutenify-template-browser-item-active';
											}
											return <li className={ classnames } key={ template.name }>
												<button className={ `gutenify-template-browser-selector` } onClick={ () => {
													const data = {
														layout: template.name,
														iconAlign: template.iconAlign,
														titleAlign: template.titleAlign,
														buttonAlign: template.buttonAlign,
													};
													setAttributes( data );
													updateInnerBlocks( template );
												} }>
													<img src={ `${ window.gutenify_block_data.plugin_directory_url }/assets/images/info-box-layouts/${ template.name }.png` } alt={ template.name } />
													<small>{ template.label }</small>
												</button></li>;
										} ) }
									</ul>
								</div> }
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);
